import { render } from "./TipoPessoa.vue?vue&type=template&id=07580e71&scoped=true"
import script from "./TipoPessoa.vue?vue&type=script&lang=js"
export * from "./TipoPessoa.vue?vue&type=script&lang=js"

import "./TipoPessoa.vue?vue&type=style&index=0&id=07580e71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07580e71"]])

export default __exports__